/**
 * @param {"IN_ANALYSIS" | "WAITING_APPROVAL" | "REFUSED" | "WAITING_CONNECTION" | "CONNECTING" | "INACTIVATION_REQUESTED" | "REJECTED" | "ACTIVE" | "INACTIVE" | "PENDING_INFORMATION" | "LOW_QUALITY_IMAGE" | "WRONG_OWNER" | "WRONG_CREDENTIALS" | "WRONG_ADDRESS" | "DUPLICITY" | "ENERGY_REPORT"} billingStatus
 */
export function formatInstallationStatusToPtBr(billingStatus) {
  const intallationStatusMap = {
    IN_ANALYSIS: 'Em análise',
    WAITING_APPROVAL: 'Aguardando aprovação',
    REFUSED: 'Recusada',
    WAITING_CONNECTION: 'Aguardando conexão',
    CONNECTING: 'Em Conexão',
    INACTIVATION_REQUESTED: 'Inativação solicitada',
    REJECTED: 'Rejeitada',
    ACTIVE: 'Ativo',
    INACTIVE: 'Inativo',
    PENDING_INFORMATION: 'Informações Pendentes',
    LOW_QUALITY_IMAGE: 'Imagem com baixa qualidade',
    WRONG_OWNER: 'Titular incorreto',
    WRONG_CREDENTIALS: 'Login ou Senha incorretos',
    WRONG_ADDRESS: 'Endereço Incorreto',
    DUPLICITY: 'Duplicidade',
    ENERGY_REPORT: 'Relatório Energia',
  }
  return intallationStatusMap[billingStatus]
}
